import { Component } from '@angular/core';

import { SelectItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

import { Observable } from 'rxjs';

import { IPaperAuthorAffiliationDialogData } from 'editing-tool/src/app/shared/components/paper/steps/authors/affiliation-dialog/paper-author-affiliation-dialog-data';
import { PaperAuthorAffiliationDialogComponent } from 'editing-tool/src/app/shared/components/paper/steps/authors/affiliation-dialog/paper-author-affiliation-dialog.component';
import { RendererBaseComponent } from 'sc-common';
import { ApiMemberAddressDetails } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    templateUrl: './paper-authors-affiliation-renderer.component.html',
    standalone: false
})
export class PaperAuthorsAffiliationRendererComponent extends RendererBaseComponent {

    public getAffiliationAction: (memberId: number) => Observable<ApiMemberAddressDetails>;

    public countries$: Observable<SelectItem[]>;

    constructor(private readonly _dialogService: DialogService) {
        super();
    }

    public openAffiliationDialog(memberId: number): void {

        const dialogData: IPaperAuthorAffiliationDialogData = {
            affiliation$: this.getAffiliationAction(memberId),
            countries$: this.countries$
        };

        this._dialogService.open(PaperAuthorAffiliationDialogComponent, {
            width: '30vw',
            header: $localize`Affiliation`,
            closable: true,
            data: dialogData
        });
    }
}
